export interface CatalogAuditSummary {
    status: 'not_ready' | 'pending' | 'ready';
    evidenceReadyRunCount: number;
    pendingRunCount: number;
    pendingMetricRowCount: number;
}

export interface CatalogAuditPresentation {
    badgeStatus: 'ready' | 'running';
    label: string;
    pulse: boolean;
    title: string;
}

const pluralize = (count: number, singular: string): string => `${count.toLocaleString()} ${singular}${count === 1 ? '' : 's'}`;

export const getCatalogAuditPresentation = (summary: CatalogAuditSummary | null | undefined): CatalogAuditPresentation | null => {
    if (!summary || summary.status === 'not_ready') return null;

    if (summary.status === 'pending') {
        return {
            badgeStatus: 'running',
            label: `Insights: finalizing (${pluralize(summary.pendingRunCount, 'run')})`,
            pulse: true,
            title: `Catalog-enriching ${pluralize(summary.pendingMetricRowCount, 'metric row')} across ${pluralize(
                summary.pendingRunCount,
                'discovery run'
            )}. Scorecard and optimization insights may be incomplete until this finishes.`
        };
    }

    return {
        badgeStatus: 'ready',
        label: 'Insights: ready',
        pulse: false,
        title: `${pluralize(summary.evidenceReadyRunCount, 'discovery run')} fully catalog-enriched.`
    };
};
